import React, { useState } from "react";
import Images from "../Simage";

function DevDepin() {
  return (
    <div className="storage_depin">
      <img src={Images.dev_depin} className="img-fluid bg_src" />
      <div className="content_sec">
        <div className="container ai-container h-100 position-relative">
          <div className="header_sec">
            <div className="lft">
              <p className="value fw-700 mb-0">Developers</p>
              <p className="value snd ylw fw-700 mb-0">DePIN your data</p>
            </div>
            <div className="ryt">
              <div>
                <p className="value fw-700 mb-0">190</p>
                <p className="value snd fw-500 mb-0">Countries</p>
              </div>
              <div>
                <p className="value fw-700 mb-0">261918</p>
                <p className="value snd fw-500 mb-0">Edge Nodes</p>
              </div>
            </div>
          </div>
          <div className="upload_sec">
            <div className="gradient_bdr">
              <p className="txt mb-0 fw-700">Upload and deliver faster</p>
              <p className="sub-txt mb-0 fw-300">
                The fastest protocols and better URL syntax
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}




export default DevDepin;
